import React, {  useState, useEffect, useRef} from 'react';
import axios from 'axios';
import Modal from "./Modal";
import ModalSale from "./ModalSale";
import Ctus from './ShowMap';
import SubscriptionRenewal from './SubscriptionRenewal';
import ReactPaginate from "react-paginate";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {aPIURL,auTHURL} from '../utils/common';
import { useReactToPrint } from 'react-to-print';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

const ExpiryDeviceList = () => 
{           
            const fileType ="xlsx";
            const tableRef = useRef(null);
            const API_URL=aPIURL();
            const AUTH_URL= auTHURL();
            const [groupId, setGroupId]= useState('1');
            const [timeZoneId, setTimeZoneId]= useState('');
            const [actionId,setActionId]= useState('1');
            const [dstatusId,setDstatusId]= useState();
            const [dID,setDID]= useState('0');
            const [dActionname,setDActionname]= useState('Save');
            const [saleSubscriptionType,setSaleSubscriptionType]= useState('1');
            const [custID,setCustID]= useState('0');
            const [sAlert,setsAlert]= useState('0');
            const [groupData,setGroupData]= useState([]);
            const [timeZoneData,setTimeZoneData]= useState([]);
            const [statusData,setStatusData]= useState([]);
            const [deviceData,setDeviceData]= useState([]);
            const [customerData,setCustomerData]= useState([]);
            const [filteredDevicedata,setFilteredDevicedata]= useState([]);
            const [filteredCustomerdata,setFilteredCustomerdata]= useState([]);
            const [allotedDeviceByCustID, setAllotedDeviceByCustID]= useState([]);
            const [subscriptionData,setSubscriptionData]= useState([]);
            const [showAddDetails,setShowAddDetails]= useState(false);
            const [showDetails,setShowDetails]= useState(false);
            const [showLocation ,setShowLocation]= useState(false);
            const [showSale,setShowSale]= useState(false);
            const [showActivate,setShowActivate] = useState(false);
            const [showDeactivate,setShowDeactivate]= useState(false);
            const [showAlert,setShowAlert]= useState(false);                
            const [post, setPost] = useState([]);
            const [order, setOrder] = useState("ASC");
            const [number, setNumber] = useState(1); // No of pages
            const [postPerPage] = useState(10);
            const [inputs, setInputs] = useState({});
            const [inputsSale, setInputsSale] = useState({});
            let [isRelay,setIsRelay]=useState(0); 
            let [devIMEINumber , setDevIMEINumber]= useState('');   
            let [devSimNumber , setDevSimNumber]= useState('');   
            let [devTypeId, setDevTypeId]= useState(7);
            const [subscriptionFor ,setSubscriptionFor] = useState(1);
            let [invoiceType,setInvoiceType]=useState("Device Renewal");
            const [btnDisplay, setBtnDisplay]= useState('none');
            const [saleSubscriptionTypeID, setSaleSubscriptionTypeID]=useState(0);
            const [dModel, setDModel]=useState("GPS-V5");
            const [cGstPer, setCGstPer]=useState(0);
            const [sGstPer, setSGstPer]=useState(0);
            const [iGstPer, setIGstPer]=useState(0);
            const [cGstVal, setCGstVal]=useState(0.00);
            const [sGstVal, setSGstVal]=useState(0.00);
            const [iGstVal, setIGstVal]=useState(0.00);
            let [discountVal, setDiscountVal]=useState(0.00);
            let [insChargeVal, setInsChargeVal]=useState(0.00);
            let [gTotalVal, setGTotalVal]=useState(0.00);
            let [totAmount,setTotAmount]=useState(0.00);
            let [payableAmount,setPayableAmount]=useState(0.00);
            let [quantity, setQuantity]=useState(0);
            const [currencyType,setCurrencyType]=useState("INR");
            const [termType,setTermType]=useState(0);
            let newduedate="";
            const d = new Date();
            let [due_Date,setDue_Date]= useState("");
            const [renewalDeviceData, setRenewalDeviceData] = useState([]);
            const [cDisplay, setCDisplay]= useState('none');
            let rc=1;
            const [devicestock, setDevicestock]=useState(0);
            let DeviceIEMI_Number=0;
            let DeviceSIM_Number=0;
            let DeviceExpirationDate="";
            let devID=0;
            let chkID=0;
            let checkStatus=false;


            useEffect(() => {
       
                FillGrid();// Zero for All
                const surls=API_URL+'GpsDeviceGroup';
                axios.post(surls).then(response => {                            
                setGroupData(response.data.data)
                }).catch(function(error){console.log(error.message);});
                
                //grid binding start 
                const durls=API_URL+'TimeZone/';
                
                axios.post(durls).then(response => {                            
                setTimeZoneData(response.data.data)
                }).catch(function(error){console.log(error.message);});
            
                setStatusData([{displayName: "Enabled", statusValue: "1",  stausId: 1},{displayName: "Disabled", statusValue: "0",  stausId: 0},{displayName: "Unassigned", statusValue: "4",  stausId: 4},{displayName: "Hold", statusValue: "3",  stausId: 3}]);
                 
            }, []);
              
              const lastPost = number * postPerPage;
              const firstPost = lastPost - postPerPage;
              const currentPost = post.slice(firstPost, lastPost);
              const PageCount = Math.ceil(post.length / postPerPage);
  
  const ChangePage = ({ selected }) => {
        
                setNumber(selected+1);
          };

const sorting=(col)=>
          {
          
            try
            {
              if(order==="ASC")
              {
                      const sorted=[...post].sort((a,b)=>
                      a[col].toLowerCase() > b[col].toLowerCase() ? 1: -1
                      );
                      setPost(sorted);
                      setOrder("DSC");
              }
              if(order==="DSC")
              {
                      const sorted=[...post].sort((a,b)=>
                      a[col].toLowerCase() < b[col].toLowerCase() ? 1: -1
                      );
                      setPost(sorted);
                      setOrder("ASC");
              }
            }
            catch(error) 
            {
              console.log(error.message);
            }                      
          }

const FillGrid=()=>
{
    
    const curls=API_URL+`GpsAdminDeviceAllList/?TypeID=7&IMEINumber=0&SimNumber=0`;  
    
    setPost([]);
    axios.post(curls).then(response => {   
                    
    setPost(response.data.data);
    console.log(response.data.data);  

     }).catch(function(error){console.log(error.message);});
}
const FilterGrid=()=>
  {
    if(devIMEINumber== '')
 { 
      devIMEINumber = '0'
 }
 if(devSimNumber== '')
 { 
      devSimNumber = '0'
 }
    const fcurls=API_URL+`GpsAdminDeviceAllList/?TypeID=${devTypeId}&IMEINumber=${devIMEINumber}&SimNumber=${devSimNumber}`;     
   
    setPost([]);
    axios.post(fcurls).then(response => {   
                    
    setPost(response.data.data);
    console.log(response.data.data);  

     }).catch(function(error){console.log(error.message);});
  }
 const FillSubscriptionDuration=(typeId)=>
  {
    
    setSubscriptionData([]);
    axios.get(API_URL+`Subscribe/${typeId}`).then(response => 
    {
          setSubscriptionData(response.data.data); 

    }).catch(function(error) 
    {
          console.log(error.message); 
    }); 
 

  }
 const showDetailsModal = (index) => {
            
       
        const d_Id = index;                           
        const urls=API_URL+`GetDeviceDetails/${d_Id}/`;
        
        axios.post(urls).then(response => {                  
        setFilteredDevicedata(response.data.data);
        }).catch(function (error) { console.log(error.message); });   
                
        setShowDetails(true);  
        setShowAddDetails(false);
        setShowSale(false);
        setShowActivate(false); 
        setShowLocation(false);
        setShowDeactivate(false);
    }
   
const closeModal = () => {
            setShowAddDetails(false);
            setShowDetails(false);
            setShowLocation(false);
            setShowSale(false);
            setShowActivate(false);
            setShowDeactivate(false);         
}
const closeAddDeviceModal = () => {

            setActionId('1'); 
            setDActionname('Save');                        
            inputs.DIMEI= "";
            inputs.AVTIMEI= "";
            inputs.DevMobile= "";
            inputs.Dremark= "";

            setShowAddDetails(false);
            setShowDetails(false);
            setShowLocation(false);
            setShowSale(false);
            setShowActivate(false);
            setShowDeactivate(false);  
            setIsRelay(0); 
            bindDeviceDetails();   
}
//const handleChange = (event) => 
 // {  
   /// setIsRelay(event.target.value);
   
 // };
const deviceAllottment=(iemiNumber) => {
       
       
    if(saleSubscriptionType === '0')
    {
        toast.error("Please select subscription duration.");
        return;
    }
    else if(custID==='0')
    {
        toast.error("Please select customer.");
        return;
    }
    else if((!inputsSale.SaleBy) || inputsSale.SaleBy ==='')
    {
        toast.error("Sales person is required.");
        return;
    }
    else
    {
           //Insert Sale Device Details
           const params = JSON.stringify({
            "accountID": custID,
            "allotmentID": 0,
            "imeiNumber": iemiNumber,
            "allotmentBy": inputsSale.SaleBy,
            "allotyName": inputsSale.SaleAllotteeName,
            "deviceID": dID,
            "subscribeID": saleSubscriptionType
         
       });
         

        axios.post(API_URL+'AllotmentDevice/', params, {
    
             "headers": 
             {
                    "content-type": "application/json",    
             },
    
        })
          .then(function (response) 
          {
            toast.success(response.data.message);              
               
          })
    
          .catch(function (error) 
          {
                 console.log(error.message);    
          });
            
            handleClear();               
        }                
}
 

const deviceDeAllottment=(allotmentID) => {
   
    if(window.confirm('Are sure want to delete?'))
             {
                const dallot_Id = allotmentID;     
                const durls=API_URL+`AllotmentDeviceDelete/${dallot_Id}/`; 
                
                axios.delete(durls).then(response => {                  
                    toast.success(response.data.message);    
                })                   
                .catch(function (error) 
                {
                    console.log(error.message);    
                });
                
                handleClear();
    } 
    else 
    {
            toast.error('Delete operation canceled by the user.');
    }
     
         
         setShowSale(false);
         setShowAlert(true);
         if(sAlert==1)
         {
                const dallot_Id = allotmentID;     
                
                const durls=API_URL + `AllotmentDeviceDelete/${dallot_Id}/`; 
               
                axios.delete(durls).then(response => {                  
                        alert(response.data.message);    
                })                   
                .catch(function (error) 
                {
                   console.log(error);    
                });
                                
                handleClear();
        }
        
       }
                  
const ChangeDGroup = (e) => {

            setGroupId(e.target.value);        
        }
    
const ChangeTimeZone = (e) => {
    
            setTimeZoneId(e.target.value);  
               
        }
const ChangeDStatus = (e) => {
    
            setDstatusId(e.target.value);      
            
        }
const ChangeCustomerID = (e) => {

        setCustID(e.target.value);
        bindAllottedDevice(e.target.value);
    }

const ChangeSubscriptionType = (e) => {

        
        setSaleSubscriptionTypeID(e.target.value);       
    }
const changeHandler = (e) => {

        const name = e.target.name;
        const value = e.target.value;
        setInputsSale(values => ({...values, [name]: value}))
      }    
const changeVHandler = (event) => {
 
  if(event.target.name==='ddiscount')
  {
      
      setCGstPer(0);
      setSGstPer(0);
      setIGstPer(0);
      setCGstVal(0.00);
      setSGstVal(0.00);
      setIGstVal(0.00);

      setDiscountVal(event.target.value);
      setGTotalVal((parseFloat(totAmount,2)  - event.target.value) + parseFloat(insChargeVal,2) + parseFloat(cGstVal,2)+ parseFloat(sGstVal,2)+ parseFloat(iGstVal,2)); 
      setPayableAmount((parseFloat(totAmount,2)  - event.target.value) + parseFloat(insChargeVal,2));   

  }
  else if(event.target.name==='installationcharge')
  {
      setSGstPer(0);
      setCGstPer(0);
      setIGstPer(0);
      setCGstVal(0.00);
      setSGstVal(0.00);
      setIGstVal(0.00);

      setInsChargeVal(event.target.value);
      setGTotalVal((parseFloat(totAmount,2) - parseFloat(discountVal,2)) + parseFloat(event.target.value)+ parseFloat(cGstVal,2)+ parseFloat(sGstVal,2)+ parseFloat(iGstVal,2));
      setPayableAmount((parseFloat(totAmount,2)  - parseFloat(discountVal,2)) + parseFloat(event.target.value,2));
      
  }
 
  else
  {
      const name = event.target.name;
      const value = event.target.value;
      setInputs(values => ({...values, [name]: value}))
  }
}

const bindAllottedDevice=(ca_Id)=>
{
    
    setAllotedDeviceByCustID([]);
    const aurls = API_URL+`AllotmentDeviceList/?AccountID=${ca_Id}`;     
    axios.get(aurls).then(response => 
      {                        
          setAllotedDeviceByCustID(response.data.data);
    }).catch(function (error) { console.log(error.message); });      
}

const onClickRegister = () => {
    
    setActionId('1'); 
    inputs.DModel = "GPS-V5";
    
    if(inputs.DModel==='')
    {
        toast.error("Device model is required.");
        return;
    }
   else if(!inputs.DIMEI)
    {
      
       toast.error("Device IMEI is required.");
       return;
    }
    else if(inputs.DIMEI.length<16 || inputs.DIMEI.length>16)
      {
        toast.error("Device IMEI should be 16 digits.");
        return;
      }

    else if(!groupId)
    {
        toast.error("Make is required.");
        return;
    }
    else if(groupId==='')
    {
        toast.error("Make is required.");
        return;
    }
    else if(!inputs.AVTIMEI)
      {
        
         toast.error("Device AVT IMEI is required.");
         return;
      }    
    else if(dstatusId==='')
    {
        toast.error("Status is required.");
        return;
    }       
  else  
  {
   
   if(actionId=='1')
   {
       
       //Insert Device Details
       const params = JSON.stringify({

      "iemiNumber": inputs.DIMEI,
      "AVTIMEI":inputs.AVTIMEI,
      "IS_Relay" :isRelay,
      "deviceName": "GPS",
      "mobileNumber": inputs.DevMobile,
      "model": "GPS-V5",
      "goupID": groupId,
      "timeZone": timeZoneId,
      "createdBy": "admin",
      "is_Active": dstatusId,
      "remarks": inputs.Dremark
    });
     

    axios.post(API_URL+'GpsDeviceRegistration/', params, {
         "headers": 
         {
                "content-type": "application/json",    
         },
    })
      .then(function (response) 
      {
           if(!response.data.validStatus)
           {
                   toast.error(response.data.message);
                   return;
           }
           else
           {
            
                 toast.success(response.data.message);
                 console.log(response.data);
         }
                       
           
      })

      .catch(function (error) 
      {
              toast.error(error.message);
              console.log(error);    
      });
            
        handleAddDeviceClear();
                  
    } 
    else
    {
        
        //Update Device Details
       const params = JSON.stringify({
        "id": dID,
        "iemiNumber": inputs.DIMEI,
        "AVTIMEI":inputs.AVTIMEI,
        "IS_Relay" :isRelay,
        "deviceName": inputs.DeviceName,
        "mobileNumber": inputs.DevMobile,
        "model": inputs.DModel,
        "goupID": groupId,
        "timeZone": timeZoneId,
        "createdBy": "admin",
        "is_Active": dstatusId,
        "remarks": inputs.Dremark           
       
      });
       

      axios.post(API_URL+'GpsDeviceEdit/', params, {
  
           "headers": 
           {
                  "content-type": "application/json",    
           },
  
      })
      .then(function (response) 
        {
           if(!response.data.validStatus)
           {
                    toast.error(response.data.message);
                    return;
           }
           else
           {
                 toast.success(response.data.message);
                 console.log(response.data);
           }         
               
        })      
       .catch(function (error) 
        {
            console.log(error);    
        });
         
            handleUpdateDeviceClear();         
              
    }
}


}

const handleClear=()=>
{

        inputsSale.SaleSubscriptionType=0;
        inputsSale.Saleby="";        
        //bind device details grid
        bindAllottedDevice(custID);  
                        
}

 
const changeAddDeviceHandler = (e) => {

 
  if(e.target.name==='DevMobile')
  {
        const re = /^[0-9\b]+$/;
        if (e.target.value === '' || re.test(e.target.value)) 
        {
         
              const name = e.target.name;
              const value = e.target.value;
              setInputs(values => ({...values, [name]: value}))
        }
        else
        {
          setInputs(values => ({...values, ['DevMobile']: ""}))
              
        }
        
  }
  else
  {
                const name = e.target.name;
                const value = e.target.value;
                setInputs(values => ({...values, [name]: value}))
  }
}

const handleRenewSubscription=(index) => {
       
    setSubscriptionFor(1);
    setInvoiceType("Device Renewal");  
    FillSubscriptionDuration(1);
    const D_Id = index;                   
    const urls = API_URL+`GetDeviceDetails/${D_Id}/`;
    
    axios.post(urls).then(response => 
    {

        inputs.customername=response.data.data[0].company;
        setCustID(response.data.data[0].accountID);      
        setActionId('2'); 
        setDActionname('Update');
        setDID(response.data.data[0].id);  
        setGroupId(response.data.data[0].groupID); 
        setTimeZoneId(response.data.data[0].timeZone);          
                 
        //inputs       
        inputs.DIMEI= response.data.data[0].iemiNumber;
        inputs.AVTIMEI= response.data.data[0].avtimei;
        inputs.DModel= response.data.data[0].model;
        inputs.DeviceName= response.data.data[0].deviceName;
        inputs.DevMobile= response.data.data[0].mobileNumber;
        inputs.DGroup= response.data.data[0].goupID;
        inputs.DTimeZone= response.data.data[0].timeZone;
        inputs.DStatus= response.data.data[0].is_Active;
        inputs.Dremark= response.data.data[0].remarks;
        setDstatusId(response.data.data[0].is_Active);
        setIsRelay(response.data.data[0].iS_Relay)
        
       
    
  });                                                        
   
        setShowAddDetails(true);
        setShowDetails(false);
        setShowLocation(false);
        setShowSale(false);
        setShowActivate(false);
        setShowDeactivate(false);            
}
const styles = {
    headsection: {
        backgroundColor:"black", color:"white",textAlign:"center"
    },
    wrapper: {
      textAlign: "center",
      margin: "0 auto",
      marginTop: "50px"
    }
  }
  const handleAddDeviceClear=()=>
  {

        setActionId('1'); 
        setDActionname('Save');
        setGroupId('1'); 
        setTimeZoneId('');   
        setDstatusId(0);
        setDID('0');          
        setDeviceData([]);    
        inputs.DIMEI= "";
        inputs.AVTIMEI= "";
        inputs.DevMobile= "";
        inputs.Dremark= "";
        //bind device details grid
        bindDeviceDetails();          
  }
  const handleUpdateDeviceClear=()=>
  {
      setGroupId('1'); 
      setTimeZoneId('');   
      setDID('0');          
      setDeviceData([]);      
      //bind device details grid
      bindDeviceDetails();   
         
  }
  const bindDeviceDetails=()=>
  {
    FilterGrid();
        
  }
  

  const exportToCSV=()=>
    {
      const newPost = post.map(({ createdBy,deviceID,groupName,timeZone,logUpdate, ...rest }) => rest);
       const ws= XLSX.utils.json_to_sheet(newPost);        
       var wscols = [
          {wch:5} ,
          {wch:10},
          {wch:20},
          {wch:10},
          {wch:20},
          {wch:20},
          {wch:20},    
          {wch:10}
      ];
   
      var wsrows = [
         {hpx: 30}
      ];
      
      ws['!cols'] = wscols;
      ws['!rows']=wsrows;
           
      let Heading = [['S.No.','NAME','IMEI NUMBER','MODEL','SIM NUMBER','ACTIVATION DATE','EXPIRATION DATE','STATUS','CUSTOMER NAME','CUSTOMER MOBILE']];
      const wb={Sheets:{Devices:ws},SheetNames:["Devices"]};
      XLSX.utils.sheet_add_aoa(ws, Heading);     
      const excelBuffer= XLSX.write(wb,{bookType:"xlsx",type:"array"});
      const data= new Blob([excelBuffer],{type:fileType});
      FileSaver.saveAs(data,"AvtDeviceReport"+".xlsx");
     }
const DIMEIchangeHandler=(e)=>
{
      setDevIMEINumber(e.target.value)
}
const DSimchangeHandler=(e)=>
{
    setDevSimNumber(e.target.value)
}
const exportDownload = e => 
{  
  
  const value = e.target.value; 
  
  if(value=="Excel")
  {
        exportToCSV();   
      
  }
  if(value=="PDF")
  {
        handlePrint(null, () => tableRef.current);
  }
}
const setSubscription_Type =(event) =>
  {
      
       if(event.target.value==1)
       {    
              setSubscriptionFor(1); 
              FillSubscriptionDuration(1);          
              setInvoiceType("Device Renewal");  
       }
       else
       {
              setSubscriptionFor(2);
              FillSubscriptionDuration(2);    
              setInvoiceType("Sim Renewal");       
       }       
  }
  const ChangeDModel=(e)=>
  {
         setDModel(e.target.value);   
  }
  const ChangeCurrency=(e)=>
  {
       setCurrencyType(e.target.value);    
  }
  const ChangeTerms=(e)=>
{
     let dterms=0;
     dterms=e.target.value;
     setTermType(dterms);
     
    
    if(e.target.value==7)
    {
        d.setDate(d.getDate() + 7);
    }
   else if(e.target.value==15)
    {
        d.setDate(d.getDate() + 15);
    }
   else if(e.target.value==30)
    {
        d.setDate(d.getDate() + 30);
    }
    else if(e.target.value==60)
    {
        d.setDate(d.getDate() + 60);
    }
    else
    {
        d.setDate(d.getDate());
    }
    let ddate=d.getDate()
    let dmonth=d.getMonth()+ 1;
    let dyear=d.getFullYear();
    if(dmonth<10)
    {
      dmonth='0'+dmonth;
    }
    newduedate=  ddate + "-" + dmonth + "-" + dyear;
    setDue_Date(newduedate);    
}
const SubmitClick=()=>
    {
      if (custID == 0) 
        {
              toast.error('Please Select Customer.')
              return
        }
        else if(saleSubscriptionTypeID== 0)
        {
              toast.error('Please Select Subscription Duration.')
              return
        }
        else if(inputs.invoicedate==='' || (!inputs.invoicedate))
          {
            toast.error('Please Select Invoice Date.')
            return
          }
        else if(inputs.SaleBy==='' || (!inputs.SaleBy))
        {
          toast.error('Sales Person is required.')
          return
        }
        else if(currencyType== "0")
        {
              toast.error('Currency is required.')
              return
        }
        else if(termType== "0")
        {
              toast.error('Payment Terms is required.')
              return
        }
        else if(inputs.deviceCost==='' || inputs.deviceCost==='0' || (!inputs.deviceCost))
        {
              toast.error('Price is required.')
              return
  
        }         
        
        else
        {
          
          const curls=API_URL+`GpsRenewalDeviceAllList/?AccountID=${custID}`;             
           axios.get(curls).then(response => 
            {        
                                  
                     setRenewalDeviceData(response.data.data);
                     console.log(renewalDeviceData);
                     setCDisplay('block');
                     setBtnDisplay('block');      
         
            }).catch(function(error) { 
              toast.error("No device available for renewal."); 
              console.log(error.message); 
              setCDisplay('none');

            });   
          }        

    }
    const ChangeCGST=(e)=>
{
    setCGstPer(e.target.value);     
    setCGstVal(parseFloat(payableAmount,2)*(parseFloat(e.target.value)/100.00));
    setGTotalVal(parseFloat(payableAmount,2) + (parseFloat(payableAmount,2)*(parseFloat(e.target.value)/100.00)) +  parseFloat(sGstVal,2) + parseFloat(iGstVal,2));
    
}
const ChangeSGST=(e)=>
{
    
    setSGstPer(e.target.value);     
    setSGstVal(parseFloat(payableAmount,2)*(parseFloat(e.target.value)/100.00));
    setGTotalVal(parseFloat(payableAmount,2) + (parseFloat(payableAmount,2)*(parseFloat(e.target.value)/100.00)) + parseFloat(cGstVal,2) +  parseFloat(iGstVal,2));
}
const ChangeIGST=(e)=>
{
    setIGstPer(e.target.value);     
    setIGstVal(parseFloat(payableAmount,2)*(parseFloat(e.target.value)/100.00));
    setGTotalVal(parseFloat(payableAmount,2) + (parseFloat(payableAmount,2)*(parseFloat(e.target.value)/100.00)) + parseFloat(cGstVal,2)+ parseFloat(sGstVal,2));
}
const ResetList=()=>
{
      setDevIMEINumber("");
      setDevSimNumber("");      
      FillGrid();
}

const SaveData=()=>
      {

        if (custID == 0) 
          {
                toast.error('Please Select Customer.')
                return
          }
          else if(saleSubscriptionTypeID== 0)
          {
                toast.error('Please Select Subscription Duration.')
                return
          }
          else if(inputs.invoicedate==='' || (!inputs.invoicedate))
            {
              toast.error('Please Select Invoice Date.')
              return
            }
          else if(inputs.SaleBy==='' || (!inputs.SaleBy))
          {
            toast.error('Sales Person is required.')
            return
          }
          else if(currencyType== "0")
          {
                toast.error('Currency is required.')
                return
          }
          else if(termType== "0")
          {
                toast.error('Payment Terms is required.')
                return
          }
          else if(inputs.deviceCost==='' || inputs.deviceCost==='0' || (!inputs.deviceCost))
          {
                toast.error('Price is required.')
                return
    
          }      
          else if(gTotalVal == 0.00)   
            {
              toast.error('Please select device from list.')
              return
  
        }  
          else
          {
                    RenewalInsert();             

          }             

      }
 const RenewalInsert=()=>
        {
                   const params = JSON.stringify({
                   
                    "customerID": parseInt(custID),
                    "invoiceDate": inputs.invoicedate,
                    "model": dModel,
                    "subscriptionDuration": parseInt(saleSubscriptionTypeID),
                    "currency": currencyType,
                    "terms": parseInt(termType),
                    "dueDate": due_Date,
                    "price": parseInt(inputs.deviceCost),
                    "stock": devicestock,
                    "quantity": parseInt(quantity),
                    "totalAmount": totAmount.toString() ,
                    "discount": discountVal.toString(),
                    "installationCharge": insChargeVal.toString(),
                    "cgstPer": parseInt(cGstPer),
                    "cgstVal": cGstVal.toFixed(2),
                    "sgstPer": parseInt(sGstPer),
                    "sgstVal": sGstVal.toFixed(2),
                    "igstPer": parseInt(iGstPer),
                    "igstVal": iGstVal.toFixed(2),
                    "grandTotal": gTotalVal.toFixed(2),
                    "invoiceType": invoiceType                
                  
                });

                                
                 //GPSDevice Sale Insert start
               
                 axios.post(API_URL+'GPSDeviceSaleInsert', params, {
                   
                    "headers": 
                     {
                         "content-type": "application/json",    
                     },
                     })
                     .then(function (response) 
                     {
                             if(!response.data.validStatus)
                             {
                                       
                                        toast.error(response.data.message);                                                                 
                             }
                             else
                             {
                                   
                                   ReadValue(response.data.id);
                                   setBtnDisplay('none');  
                                   toast.success(response.data.message); 
                                                                  
                           }      
                     })
                     .catch(function (error) 
                     {
                           toast.error("Some Error occured while saving sale device record,Please Provide Valid Inputs.");                  
                           console.log(error.message);    
                     });
                     
                     //GPSDevice Sale Insert ends   
                    
        }
        
      
const ReadValue=(ResID)=>
      {
          
          var table = document.getElementById("example"),rIndex,cIndex;
              
          var i = 0;var col=0;
      
             for(var j=1;j<table.rows.length;j++)
              {
                  
                  for(var col=0;col<table.rows[0].cells.length;col++)
                  { 
      
                         if(table.rows[0].cells[col].innerHTML==="Select")
                         {

                              DeviceIEMI_Number = document.getElementById("checkbox"+j).value;
                              checkStatus =  document.getElementById("checkbox"+j).checked
                              chkID=table.rows[j].cells[col].innerHTML;
                                                                                        
                         } 
                         else if(table.rows[0].cells[col].innerHTML==="Device ID")
                         {
                              
                              devID=table.rows[j].cells[col].innerHTML;
                                         
                                                                        
                         } 
                         else if(table.rows[0].cells[col].innerHTML==="IMEI#")
                          {
                               
                                DeviceIEMI_Number=table.rows[j].cells[col].innerHTML;
                               
                                                                    
                          }
                          else if(table.rows[0].cells[col].innerHTML==="SIM#")
                           {
                                
                                 DeviceSIM_Number=table.rows[j].cells[col].innerHTML;
                                
                                                                     
                           }   
                           else if(table.rows[0].cells[col].innerHTML==="Expired Device")
                            {
                                 
                                  DeviceExpirationDate=table.rows[j].cells[col].innerHTML;
                                
                                                                      
                            }                        
                         else
                         {
      
                         }       
                  }

                  if(checkStatus)
                    {
                      
                      const allotmentparams = JSON.stringify({
                        "accountID": parseInt(custID),
                        "allotmentID": 0,
                        "imeiNumber": DeviceIEMI_Number,
                        "allotmentBy": inputs.SaleBy,
                        "allotyName": "",
                        "deviceID": devID,
                        "subscribeID": parseInt(saleSubscriptionTypeID),
                        "invoiceID": ResID,
                        "rechargeType": invoiceType,
                        "simNumber": DeviceSIM_Number,
                        "price": inputs.deviceCost,
                        "ExpirationDate": DeviceExpirationDate, 
                     
                     });

                   

                      axios.post(API_URL+'Device_Renewal/', allotmentparams, {
          
                            "headers": 
                            {
                                  "content-type": "application/json",    
                            },       
                          })
                        .then(function (response) 
                        {
                                //toast.success(response.data.message);              
                        })
                        .catch(function (error) 
                         {
                              //toast.error("Some Error occured while saving record.");
                              //toast.error(error);
                              console.log(error.message);    
                          });
                  }
              }
                
             
      }
const handleChange = (e) => {

       if(e.target.checked)
        {
            setCGstPer(0);
            setSGstPer(0);
            setIGstPer(0);
            setCGstVal(0.00);
            setSGstVal(0.00);
            setIGstVal(0.00);
            setDiscountVal(0);
            setInsChargeVal(0);
            setQuantity(quantity+1);
            setTotAmount((quantity+1)*inputs.deviceCost);
            setGTotalVal((quantity+1)*inputs.deviceCost);
            setPayableAmount((quantity+1)*inputs.deviceCost);
        }
        else
        {
             setCGstPer(0);
             setSGstPer(0);
             setIGstPer(0);
             setCGstVal(0.00);
             setSGstVal(0.00);
             setIGstVal(0.00);
             setDiscountVal(0);
             setInsChargeVal(0);
             setQuantity(quantity-1);
             setTotAmount((quantity-1)*inputs.deviceCost);
             setGTotalVal((quantity-1)*inputs.deviceCost);
             setPayableAmount((quantity-1)*inputs.deviceCost);
        }
}      
const handlePrint = useReactToPrint({
  documentTitle: "Device Details",
  onBeforePrint: () => console.log("before printing..."),
  onAfterPrint: () => console.log("after printing..."),
  removeAfterPrint: true,
});
const exportStatus = e => {

 if(devIMEINumber== '')
 { 
      devIMEINumber = '0'
 }
 if(devSimNumber== '')
 { 
      devSimNumber = '0'
 }
    const dev_typeId = e.target.value;
    setDevTypeId(e.target.value);
    const filterurls=API_URL+`GpsAdminDeviceAllList/?TypeID=${dev_typeId}&IMEINumber=${devIMEINumber}&SimNumber=${devSimNumber}`;  
   
    setPost([]);
    axios.post(filterurls).then(response => {   
                    
                setPost(response.data.data);
                console.log(response.data.data);  

           }).catch(function(error){console.log(error.message);});
  }

  return (
    <>   
        <div>
          {/*Show Device Model*/}
 <Modal isOpen={showDetails} >  
               
              <div class="modal-header">
                <h5 className='modal-title'>View Details</h5>
                <button type="button" class="btn-close" onClick={closeModal}></button>
                </div>
                <div class="modal-body">   

                    <div class="container">
   
    <div class="row">
     
      <div class="col-md-12">
      <div class="accordion" id="AVTFAQ">
  <div class="accordion-item">
    <h2 class="accordion-header" id="headingOne">
      <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#faq-1" aria-expanded="true" aria-controls="collapseOne">
     Customer Details
      </button>
    </h2>
    <div id="faq-1" class="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#AVTFAQ">
      <div class="accordion-body">
      <p>  
        <table >
                {filteredDevicedata.map(devdata1 => (
                <tr key={devdata1.id}>
                    <td>                    
                    <div class="row">
                    <div class="col-sm-6 col-md-4 form-group">&nbsp;
                    <b> Cutomer Name : </b>        
                    {devdata1.company}
                    </div>
                    <div class="col-sm-6 col-md-4 form-group">&nbsp;
                    <b> Mobile No : </b>        
                    {devdata1.customerMobile}
                    </div>
                    <div class="col-sm-6 col-md-4 form-group">&nbsp;
                    <b> Email : </b>        
                    {devdata1.customerEmail}
                    </div>
                     <div class="col-sm-6 col-md-4 form-group">&nbsp;
                    <b> Country : </b>        
                    {devdata1.customerCountry}
                    </div>
                    <div class="col-sm-6 col-md-4 form-group">&nbsp;
                    <b> State : </b>        
                    {devdata1.customerState}
                    </div>
                    <div class="col-sm-6 col-md-4 form-group">&nbsp;
                    <b> City : </b>        
                    {devdata1.customerCity}
                    </div>
                     <div class="col-sm-6 col-md-4 form-group">&nbsp;
                    <b> Pincode : </b>        
                    {devdata1.customerPincode}
                    </div>
                    <div class="col-sm-6 col-md-4 form-group">&nbsp;
                    <b> Customer Type : </b>        
                    {devdata1.customerType}
                    </div>
                    <div class="col-sm-6 col-md-4 form-group">&nbsp;                     
                    </div>
                    </div>               
                    </td>                            
                </tr>
                 ))}
                </table></p>
      </div>
    </div>
  </div>
  <div class="accordion-item">
    <h2 class="accordion-header" id="headingTwo">
   <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faq-2" aria-expanded="false" aria-controls="collapseTwo">    
      Device Details 
      </button>
      
    </h2>
    <div id="faq-2" class="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#AVTFAQ">
      <div class="accordion-body">
      <p>  <table >
                {filteredDevicedata.map(devdata1 => (
                <tr key={devdata1.id}>
                    <td>                    
                    <div class="row">
                    
                <div class="col-sm-6 col-md-4 form-group">&nbsp;
                    <b> Device Name : </b>        
                    {devdata1.deviceName}
                    </div>
                <div class="col-sm-6 col-md-4 form-group">&nbsp;
                    <b> Model : </b>       
                    {devdata1.model}
                    </div>
                <div class="col-sm-6 col-md-4 form-group">&nbsp;
                    <b> IMEI No : </b>      
                    {devdata1.iemiNumber}
                    </div>                                   
                <div class="col-sm-6 col-md-4 form-group">&nbsp;
                    <b> SIM No : </b>       
                    {devdata1.mobileNumber}
                    </div>
                <div class="col-sm-6 col-md-4 form-group">&nbsp;
                    <b> Group : </b>        
                    {devdata1.groupName}
                    </div>
                <div class="col-sm-6 col-md-4 form-group">&nbsp;
                    <b> Time-Zone : </b>      
                    {devdata1.timeZone}
                    </div>
                    <div class="col-sm-6 col-md-4 form-group">&nbsp;
                    <b> Activation Date : </b>        
                    {devdata1.activationDate}
                    </div>
                    <div class="col-sm-6 col-md-4 form-group">&nbsp;
                    <b> Expiration Date : </b>       
                    {devdata1.expirationDate}
                    </div>
                    <div class="col-sm-6 col-md-4 form-group">&nbsp;
                    <b> Status : </b>        
                   {devdata1.status}                   
                    </div>                    
                    </div>               
                    </td>                            
                </tr>
                 ))}
                </table></p>
      </div>
    </div>
  </div>
  <div class="accordion-item">
    <h2 class="accordion-header" id="headingThree">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faq-3" aria-expanded="false" aria-controls="collapseThree">
      Driver Details 
      </button>
    </h2>
    <div id="faq-3" class="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#AVTFAQ">
      <div class="accordion-body">
      <p> <table >
                {filteredDevicedata.map(devdata1 => (
                <tr key={devdata1.id}>
                <td>                    
                <div class="row">                
                <div class="col-sm-6 col-md-4 form-group">&nbsp;
                    <b> Driver Name : </b>      
                    {devdata1.driverName}
                    </div>
                    <div class="col-sm-6 col-md-4 form-group">&nbsp;
                    <b> Father Name : </b>       
                    {devdata1.fatherName}
                    </div>
                    <div class="col-sm-6 col-md-4 form-group">&nbsp;
                    <b> Contact No : </b>        
                    {devdata1.contactNumber}
                    </div>
                    <div class="col-sm-6 col-md-4 form-group">&nbsp;
                    <b> License No : </b>       
                    {devdata1.licenceNumber}
                    </div>
                    <div class="col-sm-6 col-md-4 form-group">&nbsp;
                    <b> License From : </b>        
                    {devdata1.licenceIssueFrom}
                    </div>
                    <div class="col-sm-6 col-md-4 form-group">&nbsp;
                    <b> License Validity : </b>      
                    {devdata1.licenceValidity}
                    </div>
                    <div class="col-sm-6 col-md-4 form-group">&nbsp;
                    <b> Address : </b>        
                    {devdata1.address}
                    </div>
                    <div class="col-sm-6 col-md-4 form-group">&nbsp;
                    <b> Identity No : </b>       
                    {devdata1.identityNumber}
                    </div>
                </div>                  
                </td>                            
                </tr>
                 )             
                )
                }
                </table></p>
      </div>
    </div>
  </div>

  <div class="accordion-item">
    <h2 class="accordion-header" id="headingThree">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faq-4" aria-expanded="false" aria-controls="collapseThree">
      Vehicle Details 
      </button>
    </h2>
    <div id="faq-4" class="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#AVTFAQ">
      <div class="accordion-body">
      <p> <table>
                {filteredDevicedata.map(devdata1 => (
                <tr key={devdata1.id}>
                    <td>                    
                    <div class="row">
                    <div class="col-sm-6 col-md-4 form-group">&nbsp;
                    <b> Vehicle No : </b>      
                    {devdata1.vehicleNumber}
                    </div>
                    <div class="col-sm-6 col-md-4 form-group">&nbsp;
                    <b> VIN : </b>       
                    {devdata1.vin}
                    </div>
                    <div class="col-sm-6 col-md-4 form-group">&nbsp;
                    <b> Engine No : </b>        
                    {devdata1.enginNumber}
                    </div>
                    <div class="col-sm-6 col-md-4 form-group">&nbsp;
                    <b> Vehicle Brand : </b>       
                    {devdata1.vehicleBrand}
                    </div>
                    <div class="col-sm-6 col-md-4 form-group">&nbsp;
                    <b> Vehicle Model : </b>        
                    {devdata1.vehicleModel}
                    </div>                   
                </div>
                </td>                            
                </tr>
                 )             
                )
                }
                </table> </p>
      </div>
    </div>
  </div>

  <div class="accordion-item">
    <h2 class="accordion-header" id="headingThree">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faq-5" aria-expanded="false" aria-controls="collapseThree">
      Peripheral Details 
      </button>
    </h2>
    <div id="faq-5" class="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#AVTFAQ">
      <div class="accordion-body">
      <p> <table>
                {filteredDevicedata.map(devdata1 => (
                <tr key={devdata1.id}>
                <td>                    
                <div class="row">
                <div class="col-sm-12 col-md-12 form-group">&nbsp;
                    <b>Relay : </b>                
                    {devdata1.iS_Relay==1? "Active Relay(OTP)": devdata1.iS_Relay==2 ? "Active Relay(NO OTP)":"Non-Active Relay"}
                    </div>                   
                </div>
                </td>                            
                </tr>
                 )             
                )
                }
                </table> </p>
           
      </div>
    </div>
  </div>

  
</div>          
</div>
</div>
</div>                         
              
                </div>
        </Modal>
 {/*Add Device Model*/}
  <ModalSale isOpen={showAddDetails} >  
        <div class="modal-header">
        <h5 className='modal-title'> Renewal Details</h5>
        <button type="button" class="btn-close" onClick={closeAddDeviceModal}></button>
        </div>
        <div class="modal-body">      
         <div class="row">
              <div className='col-md-4 col-lg-4 form-group'>
              Customer <span style={{color:"red"}}>&nbsp;*</span><br/>
              <input type="text" class="form-control" tabindex="1" id="txtCustomerName"  disabled={true} value={inputs.customername}/>              
              </div>
              <div className='col-md-2 col-lg-2  form-group' onChange={setSubscription_Type.bind(subscriptionFor)} >
              Renewal For 
              <span style={{color:"red"}}>&nbsp;*</span><br/>
              <input type="radio"  value="1" name="ignitionAlert" checked={subscriptionFor === 1?true:false}/> Device              
              </div>
              <div className='col-md-2 col-lg-2 form-group'>
              Duration <span style={{color:"red"}}>&nbsp;*</span><br/>               
              <select className="form-control"  name="DSubscriptionType" value={saleSubscriptionTypeID} onChange={ChangeSubscriptionType} >
              <option value={0}>Select Duration</option>
              {subscriptionData.map((e, key) => {
              return <option key={key} value={e.id}>{e.subscribeName}</option>;
              })}
              </select>  
              </div>
            
              <div className='col-md-2 col-lg-2 form-group'>
              Invoice Date  <span style={{color:"red"}}>&nbsp;*</span>
              <input name="invoicedate"  type="date" className="form-control"  value={inputs.invoicedate}  onChange={changeVHandler}/>
              </div>
              <div className='col-md-2 col-lg-2 form-group'>
                            Model 
                            <select className="form-control" name="DModel" value={dModel}  onChange={ChangeDModel} >
                            <option value={"GPS-V5"}>GPS-V5</option>               
                            </select>
              </div>
              
              <div className='col-md-4 col-lg-4 form-group'>
              Sales Person : <span style={{color:"red"}}>&nbsp;*</span>  
              <input name="SaleBy"  type="text"   className="form-control"  value={inputs.SaleBy} onChange={changeVHandler}></input>    
              </div>                                                
              <div className='col-md-2 col-lg-2 form-group'>
              Currency <span style={{color:"red"}}>&nbsp;*</span>
                            <select className="form-control" name="dcurrency" value={currencyType}  style={{ "backgroundColor":"white", "float": "right","margin-right": "5px","height": "15px"}}  onChange={ ChangeCurrency} >
                            <option value={"0"}>Select</option>    
                            <option value={"INR"}>INR-Indian Rupee</option>  
                            <option value={"CAD"}>CAD-Canadian Dollar</option>   
                            <option value={"USD"}>USD-US Dollars</option>             
                            </select> 
              </div>
              <div className='col-md-2 col-lg-2 form-group'>
              Payment Terms <span style={{color:"red"}}>&nbsp;*</span>
              <select className="form-control" name="dterms"   value={termType} style={{ "backgroundColor":"white", "float": "right","margin-right": "5px","height": "15px"}} onChange={ ChangeTerms }  >
                            <option value={0}>Select Term</option> 
                            <option value={7}>7 Days</option>    
                            <option value={15}>15 Days</option>  
                            <option value={30}>30 Days</option>   
                            <option value={60}>60 Days</option>           
                </select> 
              </div>
              <div className='col-md-2 col-lg-2 form-group'>
              Due Date 
              <br/>
              <input name="deviceCost"  type="text"  disabled={true} className="form-control"  value={due_Date}  />
              
              </div>
              <div className='col-md-2 col-lg-2 form-group'>
               Price <span style={{color:"red"}}>&nbsp;*</span>
               <input name="deviceCost"  type="text"  maxLength={5} className="form-control"  value={inputs.deviceCost}  onChange={changeVHandler}/>
              </div>
               <div className='col-md-12 col-lg-12  form-group' style={{ marginTop: "17px"}}>
               <center>   <button className="btn btn-primary2" onClick={() => SubmitClick()}>Add</button> </center>
               </div>  
                <div className="row" style={{ padding:"20px", height: "222px", overflowY: "auto" , display: cDisplay }} >
            <table id="example" class="table table-striped table-bordered table-hover" style={{width:"100%"}}>
            <thead>
            <tr>
                   <th style={{ textAlign: "center"}} width="5%">Select</th>
                    <th style={{ textAlign: "center"}} width="10%">Device ID</th>
                    <th style={{ textAlign: "center"}} width="10%">Name</th>                   
                    <th style={{ textAlign: "center"}} width="25%">IMEI#</th>
                    <th style={{ textAlign: "center"}} width="20%">SIM#</th>
                    <th style={{ textAlign: "center"}} width="25%">Expiry Date</th>
                    <th style={{ textAlign: "center"}} width="10%">Price</th>
                    
                                      
            </tr>
            </thead>
            <tbody>
                {renewalDeviceData.map(item => (                    
                <tr key={item.id}>
                 <td style={{ textAlign:"center"}}>  
                 <input  className="form-check-input"  type="checkbox" name={'checkbox'+ rc}  value={item.imeiNumber}  id={'checkbox'+ rc}  onChange={ handleChange } />  </td> 
                  <td style={{ textAlign: "center"}}>{item.id}</td>
                  <td style={{ textAlign:"center"}}>{item.devicename}</td>                  
                  <td style={{ textAlign:"center"}}>{item.imeiNumber}</td>
                  <td style={{ textAlign:"center"}}>{item.mobileNumber}</td>
                  <td style={{ textAlign:"center"}}>{item.expirationDate}</td>
                  <td style={{ textAlign:"center"}}>{inputs.deviceCost}</td>                  
                  <td style={{"display":"none"}}>{rc++}</td> 
                </tr>
                ))}                
            </tbody>
            </table>
            </div>
            <div className='row' style={{ display: cDisplay }}>
                <table>
                    <tr>
                        <td style={{ width:"50%" }}></td>
                        <td style={{ width:"20%" }}>Total Amount</td>
                        <td style={{ width:"10%" }}></td>
                        <td style={{ width:"17%" }}> <input name="totAmount"  type="text"  maxLength={10} className="form-control" style={{textAlign:"right"}}  value={ totAmount.toFixed(2) }  onChange={changeVHandler}/></td>
                        <td style={{ width:"3%" }}></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>Discount</td>
                        <td></td>
                        <td> <input name="ddiscount"  type="text"  maxLength={5} className="form-control"  style={{textAlign:"right"}} value={discountVal}  onChange={changeVHandler}/></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td >Installation Charge</td>
                        <td></td>
                        <td> <input name="installationcharge"  type="text"  maxLength={5} className="form-control"  style={{textAlign:"right"}} value={insChargeVal}  onChange={changeVHandler}/></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>CGST%</td>
                        <td>
                            <select className="form-control" name="cgst"   style={{ "backgroundColor":"white", "float": "right","margin-right": "5px","height": "15px", "padding": "5px 5px"}} value={cGstPer} onChange={ ChangeCGST }  >
                            <option value={0}>Select</option> 
                            <option value={9}>9%</option>   
                            <option value={18}>18%</option>        
                            </select>
                        </td>
                        <td> <input name="cgst"  type="text"  maxLength={5} className="form-control"  style={{textAlign:"right"}} value={cGstVal.toFixed(2)}  onChange={changeVHandler}/></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>SGST%</td>
                        <td> <select className="form-control" name="sgst"   style={{ "backgroundColor":"white", "float": "right","margin-right": "5px","height": "15px", "padding": "5px 5px"}} value={sGstPer}  onChange={ ChangeSGST } >
                            <option value={0}>Select</option> 
                            <option value={9}>9%</option>   
                            <option value={18}>18%</option>           
                            </select> 
                        </td>
                        <td><input name="sgst"  type="text"  maxLength={5} className="form-control" style={{textAlign:"right"}} value={sGstVal.toFixed(2)}  onChange={changeVHandler} /></td>
                    </tr>
                    <tr><td></td>
                        <td>IGST%</td>
                        <td><select className="form-control" name="igst"   style={{ "backgroundColor":"white", "float": "right","margin-right": "5px","height": "15px", "padding": "5px 5px"}} value={iGstPer}  onChange={ ChangeIGST }  >
                            <option value={0}>Select</option> 
                            <option value={9}>9%</option>   
                            <option value={18}>18%</option>              
                            </select></td>
                        <td> <input name="igst"  type="text"  maxLength={5} className="form-control"  style={{textAlign:"right"}} value={iGstVal.toFixed(2)}  onChange={changeVHandler}/></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>Grand Total</td>
                        <td></td>
                        <td> <input name="gtotal"  type="text"  maxLength={5} className="form-control"  style={{textAlign:"right"}} value={ gTotalVal.toFixed(2) }  onChange={changeVHandler}/></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                </table>
                </div>     
       <div className='col-md-12 col-lg-12  form-group' style={{ display: btnDisplay, marginTop: "17px"}}>
           <center>    <button className="btn btn-primary2" onClick={() => SaveData()}>Save</button> </center>
               </div>
                
      
       </div>
       </div>
        </ModalSale>
            
                    
       
                    
        </div>
        {/**/}
        <div className="top-bar clearfix">
        <div className="row">
       
        <div className="col-md-4">
        <h2> Expiry Devices </h2>           
        </div>
          <div className="col-md-8 text-right">            
           <select onChange={exportStatus} className="btn btn-primary" name="Export">
          <option value={"7"}>Expiring Soon</option>  
          <option value={"8"}>Grace Period</option>
          <option value={"9"}>Deactivated</option>
          
          </select> 
          <select onChange={exportDownload} className="btn btn-primary" name="Download" >
          <option value={"Download"}>Download</option>    
          <option value={"Excel"}>Excel</option>    
          <option value={"PDF"}>PDF</option>                      
          </select>
          </div>
        </div>
      </div>    
      <div className="container-fluid p-3">
      <div class="card mb-3 shadow no-border border-0">
  <div class="card-body">
    <div class="row align-items-end">  
    <div class="col-sm-3 col-lg-2">IMEI NUMBER <input type="text" class="form-control" tabindex="1" id="txtImeiNumber"   maxlength="20" value={devIMEINumber} onChange={DIMEIchangeHandler}/>
    </div>
    <div class="col-sm-3 col-lg-2">Sim NUMBER <input type="text" class="form-control" tabindex="2" id="txtSimNumber"   maxlength="20" value={devSimNumber} onChange={DSimchangeHandler}/>
    </div>
    
    <div class="col-sm-4 col-lg-2">
    <button type="button" class="btn btn-primary2 mt-20" tabindex="3" id="btnSearchNew" onClick={FilterGrid} >Search</button>
    <button type="button" class="btn btn-secondary mt-20" id="btnResetNew" tabindex="4" onClick={ResetList} >Reset   </button></div>
    <div class="col-sm-3 col-lg-2"> </div>
    </div>    
  </div></div>
  <div className="container-fluid p-3">
    <div class="card mb-3 shadow no-border border-0">
    <div class="card-body p-0">
    <table ref={tableRef}  id="example" class="table table-striped table-bordered table-hover" style={{width:"100%"}}>
    <thead>
    <tr><th width="3%" >S.No.</th>
    <th width="19%" onClick={()=>sorting("customerName") } style={{textAlign:"center","cursor": "pointer"}}>Customer NAME &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
    <th width="10%" onClick={()=>sorting("customerMobile") } style={{textAlign:"center","cursor": "pointer"}}>Mobile No &nbsp;<i class="fa-sharp fa-solid fa-sort"></i></th>
    
    <th width="10%" onClick={()=>sorting("imeiNumber") } style={{textAlign:"center","cursor": "pointer"}}>IMEI NUMBER &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
    <th width="10%" onClick={()=>sorting("mobileNo") } style={{textAlign:"center","cursor": "pointer"}} >SIM NUMBER &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
    
    <th width="10%" onClick={()=>sorting("activationDate") } style={{textAlign:"center","cursor": "pointer"}}>ACTIVATION DATE &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
    <th width="10%" onClick={()=>sorting("expirationDate") } style={{textAlign:"center","cursor": "pointer"}}>EXPIRATION DATE &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
    <th width="10%" onClick={()=>sorting("logUpdate") } style={{textAlign:"center","cursor": "pointer"}}>Log Update &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
    <th width="8%" onClick={()=>sorting("status") } style={{textAlign:"center","cursor": "pointer"}}>STATUS &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
    <th width="10%" onClick={()=>sorting("id") } style={{textAlign:"center"}}>Action </th>
    </tr>
    </thead>
    <tbody>
    {currentPost.map((devdata) => {
                return (
                <tr key={devdata.id}>
                  <td style={{textAlign:"center"}}>{devdata.id}</td>
                  <td>{devdata.customerName}</td>
                  <td style={{textAlign:"center"}}>{devdata.customerMobile}</td>
                  
                  <td style={{textAlign:"center"}}>{devdata.imeiNumber}</td>
                  <td style={{textAlign: "center"}}>{devdata.mobileNo}</td>
                  
                  <td style={{textAlign:"center"}}>{devdata.activationDate}</td>
                  <td style={{textAlign:"center"}}>{devdata.expirationDate}</td>
                  <td style={{textAlign:"center"}}>{devdata.logUpdate}</td>
                  <td style={{textAlign:"center"}}>{devdata.status}</td>
                  <td style={{textAlign:"center", fontSize:"16px"}}>
                  <i onClick={() => showDetailsModal(devdata.deviceID)} style={{ color:"green", cursor:'pointer'}} className="fa-solid fa-list" title="View Details"></i>
                  &nbsp;&nbsp; <i onClick={() => handleRenewSubscription(devdata.deviceID)} style={{ color:"#fdaf06ff", cursor:'pointer'}} className="fa-solid fa-pen-to-square" title="Renew Subscription"></i>
                              
                  </td>
                </tr>
               );
            })}
            </tbody>
            </table>
            <ReactPaginate  previousLabel={"<<"}  nextLabel={">>"}  pageCount={PageCount}  onPageChange={ChangePage}  disableInitialCallback={true}
            initialPage={0}  containerClassName={'pagination justify-content-end'} pageClassName={'page-item'} pageLinkClassName={'page-link'}  previousClassName={'page-item'}
            previousLinkClassName={'page-link'}  nextClassName={'page-item'}  nextLinkClassName={'page-link'}  breakClassName={'page-item'}  breakLinkClassName={'page-link'}  activeClassName={'active'}></ReactPaginate>       
            </div> </div> 
            </div>
            </div>
            <ToastContainer position="bottom-right" autoClose={4000} theme="light"/>       
            </>
    );
    }   
export default ExpiryDeviceList;
